function FooterMenu(props) {
  return (
    <div className="mx-auto pb-5 w-full p-10">
      <h1 className="text-xl font-bold">{props.title}</h1>
      {props.item.map((item, index) => {
        return <p className="text-[#6A983C]">{item}</p>;
      })}
    </div>
  );
}

export default FooterMenu;
